import React from 'react';

export default function Link(props) {
  let classes = "mdl-navigation__link";
  if(props.upper) {
    classes += " mdl-typography--text-uppercase";
  }
  return <a className={classes} href={`#${props.link}`}>{`${props.name}`}</a>
}



// WEBPACK FOOTER //
// ./src/Link/Link.js